export const deployedContracts = {
  fc: 'Q1ga6CExJs-AARQi3mvtFiPcdZmXi_8e22QURdhrnug',
};
